export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20and%20modern%20abstract%20geometric%20composition%20with%20soft%20gradients%20of%20warm%20orange%2C%20coral%2C%20and%20cream%20white%20tones%2C%20smooth%20flowing%20shapes%20with%20subtle%20texture%2C%20minimalist%20and%20elegant%20design%20with%20clean%20lines%2C%20professional%20corporate%20aesthetic%2C%20warm%20ambient%20lighting%2C%20no%20text%2C%20no%20people%2C%20abstract%20digital%20art%20style%20suitable%20for%20website%20hero%20background&width=1920&height=900&seq=hero-bg-17c-001&orientation=landscape"
          alt="17c一起草官网入口"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 flex flex-col items-center text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-6">
          <i className="ri-verified-badge-line text-accent-400 text-sm"></i>
          <span className="text-white/90 text-xs font-medium">官方正版认证 · 永久有效入口</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-5 leading-tight max-w-3xl">
          17c一起草官网入口
        </h1>

        <p className="text-base md:text-lg text-white/80 mb-3 max-w-xl">
          官方正版直达通道 · 安全稳定 · 永久有效
        </p>

        <p className="text-sm text-white/60 mb-8 max-w-2xl leading-relaxed">
          提供17c一起草官网入口最新地址、安全登录通道及完整功能体验。收藏本页永久有效，告别失效链接烦恼。
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3">
          <a
            href="#entrance"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-300 hover:scale-105"
          >
            立即进入官网
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <a
            href="#features"
            className="px-8 py-3.5 rounded-full border border-white/30 text-white font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-white/10 transition-all duration-300"
          >
            了解更多
            <i className="ri-arrow-down-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}